import React, { useState, useEffect } from "react";
import {
  Container,
  Label,
  Button,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import ApiCaller from "../../../../api/apiCaller";
import SelectBuilding from "./SelectBuilding";
import CreateBuilding from "./CreateBuilding";
import ConfirmBuilding from "./ConfirmBuilding";
import "./index.css";
import t from "utils/Lang";

interface CreateNewSiteModalInputProps {
  isShow: boolean;
  toggleFunction: () => void;
}

const CreateNewSiteModal = ({
  isShow,
  toggleFunction,
}: CreateNewSiteModalInputProps) => {
  const [selectedWizardStep, setSelectedWizardStep] =
    useState<string>("select_site_type");
  const [storeTypes, setStoreTypes] = useState<Array<any>>([]);
  const [storeFormats, setStoreFormats] = useState<Array<any>>([]);
  const [selectedStoreTypeId, setSelectedStoreTypeId] = useState<number | null>(
    1
  );
  const [selectedStoreFormatId, setSelectedStoreFormatId] = useState<
    number | null
  >(1);
  const [selectedBuildingId, setSelectedBuildingId] = useState<number | null>(
    null
  );

  const processWizardStep = () => {
    if (selectedWizardStep === "select_site_type") {
      if (selectedStoreFormatId === 2) {
        setSelectedWizardStep("select_building");
      } else {
        window.location.href = `/sitev2-create?store_format_id=${selectedStoreFormatId}&store_type_id=${selectedStoreTypeId}`;
      }
    }
    if (selectedWizardStep === "confirm_building") {
      window.location.href = `/sitev2-create?location_id=${selectedBuildingId}&store_format_id=${selectedStoreFormatId}&store_type_id=${selectedStoreTypeId}`;
    }
  };

  const updateSelection = (selectionType: string, value: string) => {
    if (selectionType === "store_type") {
      setSelectedStoreTypeId(parseInt(value, 10));
    } else if (selectionType === "store_format") {
      setSelectedStoreFormatId(parseInt(value, 10));
    }
  };

  /* Store type */
  const getStoreTypes = async () => {
    const options: Array<any> = [];
    const res = await ApiCaller.get(`store_type/`);
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        options.push({
          id: item?.id,
          name: item?.name,
        });
      });
      setStoreTypes(options);
    }
  };
  /* End Store type */

  /* Store format */
  const getStoreFormats = async () => {
    const options: Array<any> = [];
    const res = await ApiCaller.get(`store_format/`);
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        options.push({
          id: item?.id,
          name: item?.name,
        });
      });
      setStoreFormats(options);
    }
  };

  /* End store format */

  /* handle building creation */
  const selectBuildingHandle = (selectedBuildingId: number) => {
    if (selectedBuildingId === 0) {
      setSelectedWizardStep("create_new_building");
    } else {
      setSelectedBuildingId(selectedBuildingId);
      setSelectedWizardStep("confirm_building");
    }
  };

  useEffect(() => {
    getStoreFormats();
    getStoreTypes();
  }, []);
  /* End Store format */

  return (
    <Modal size="lg" isOpen={isShow} toggle={toggleFunction}>
      <ModalHeader toggle={toggleFunction}>
        {t().modal_create_site__title}
      </ModalHeader>
      <ModalBody>
        {selectedWizardStep === "select_site_type" && (
          <div>
            <div style={styles.section}>
              <p>{t().modal_create_site__store_type}</p>
              {storeTypes && (
                <div style={styles.selectionBox}>
                  {storeTypes.map((storeType) => (
                    <div style={styles.radioWrapper} key={storeType.id}>
                      <input
                        type="radio"
                        value={storeType.id}
                        onChange={(e) =>
                          updateSelection("store_type", e.target.value)
                        }
                        checked={selectedStoreTypeId === storeType.id}
                      />
                      <label style={styles.radioLabel}>{storeType.name}</label>
                      <br />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={styles.section}>
              <p>{t().modal_create_site__store_format}</p>
              {storeFormats && (
                <div style={styles.selectionBox}>
                  {storeFormats.map((storeFormat) => (
                    <div style={styles.radioWrapper} key={storeFormat.id}>
                      <input
                        type="radio"
                        value={storeFormat.id}
                        onChange={(e) =>
                          updateSelection("store_format", e.target.value)
                        }
                        checked={selectedStoreFormatId === storeFormat.id}
                      />
                      <label style={styles.radioLabel}>
                        {storeFormat.name}
                      </label>
                      <br />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {selectedWizardStep === "select_building" && (
          <SelectBuilding selectBuildingCallback={selectBuildingHandle} />
        )}
        {selectedWizardStep === "create_new_building" && (
          <CreateBuilding selectBuildingCallback={selectBuildingHandle} />
        )}
        {selectedWizardStep === "confirm_building" && (
          <ConfirmBuilding buildingId={selectedBuildingId} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleFunction}>
          {t().action__cancel}
        </Button>
        <Button color="primary" onClick={processWizardStep}>
          {t().action__continue}
        </Button>{" "}
      </ModalFooter>
    </Modal>
  );
};

const styles = {
  section: {
    marginTop: 12,
  },
  selectionBox: {
    display: "flex",
  },
  radioWrapper: {
    marginRight: 24,
  },
  radioLabel: {
    marginLeft: 6,
  },
};

export default CreateNewSiteModal;
